import { Elena } from '@elenajs/core';

const commandforSupported = 'command' in HTMLButtonElement.prototype;

export default class LpCarousel extends Elena(HTMLElement) {
	static tagName = 'lp-carousel';

	connectedCallback() {
		super.connectedCallback();

		if (!commandforSupported) {
			this.addEventListener('click', e => {
				if (e.target.closest('[commandfor]')) {
					const command = e.target
						.closest('[commandfor]')
						.getAttribute('command');

					if (command === 'show-modal') {
						e.target.closest('[commandfor]')?.nextElementSibling?.showModal();
					} else if (command === 'close') {
						e.target.closest('dialog')?.close();
					}
				}
			});
		}

		const [backward, forward] = this.querySelectorAll(':scope > button');
		const root = this.querySelector('ul');
		const { children } = root;

		let current = children[0];

		this.addEventListener('click', e => {
			if (e.target?.attributes.left) {
				current.previousElementSibling?.scrollIntoView({
					block: 'nearest',
					inline: 'center',
					behavior: 'smooth',
					container: 'nearest'
				});
			} else if (e.target?.attributes.right) {
				current.nextElementSibling?.scrollIntoView({
					block: 'nearest',
					inline: 'center',
					behavior: 'smooth',
					container: 'nearest'
				});
			}
		});

		let timeout;
		const ioCb = entries => {
			clearTimeout(timeout);

			const intersecting = entries.find(entry => entry.isIntersecting);
			if (!intersecting) return;

			current = intersecting.target;

			const index = [...children].indexOf(current);

			index > 0
				? backward.removeAttribute('disabled')
				: backward.setAttribute('disabled', true);

			index === children.length - 1
				? forward.setAttribute('disabled', true)
				: forward.removeAttribute('disabled');

			timeout = setTimeout(ioCb(observer.takeRecords(), 250));
		};

		const observer = new IntersectionObserver(ioCb, {
			root,
			threshold: 0,
			rootMargin: '0% -50%',
			delay: 1
		});

		[...children].forEach(child => observer.observe(child));
	}
}

LpCarousel.define();
